import {times, extend, clamp} from 'lodash';
import * as React from 'react';
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'react-recompose'. '/home/runner/work/flow-to-typescript-codemod/flow-to-typescript-codemod/webflow/node_modules/react-recompose/dist/Recompose.cjs.js' implicitly has an 'any' type.
import {compose, withHandlers} from 'react-recompose';
import ScrollView from './ScrollView';
import {Note, useRegisterLegacyOverlay} from '@packages/systems/spring';
import {
  Layer,
  Locator,
  OverlayBox,
  useSpringModalViewport,
} from '@packages/systems/ui/overlay';
import {translate} from '@packages/utilities/inline-style-utils';
import {emptyArray} from '@packages/utilities/fp/utils';
import {place, positions, pad, padHorizontal} from '@packages/utilities/box';
import {getAutomationId, DATA_AUTOMATION_ID} from './constants/AutomationUtils';
import {useTheme} from '@packages/utilities/styled';
import {syncPropsToState} from '@packages/utilities/component';

import {Card} from './Card';
import * as Menu from './Menu';
import TooltipTrigger from './TooltipTrigger';

import {
  open as openUpdater,
  close,
  scroll,
  groups,
  change,
  getValue,
  getLabel,
  preselect,
  menuHeight,
  selectedTop,
  groupHeight,
  indexInGroup,
  handleKeyDown as onKeyDown,
  getInitialState,
  getOptionHeight,
  getOptionMargins,
  calculateOptionPositions,
  DropdownGroupSymbol,
} from './logic/dropdown';
import type {CSSProperties} from '@packages/utilities/css-properties-type';
import {FloatingNode} from '@floating-ui/react';

type OptionProps = {
  label?: React.ReactNode;
  value?: any;
  disabled?: boolean;
  selectable?: boolean;
  style?: React.CSSProperties;
  header?: boolean;
  isNoteItem?: boolean;
  id?: string;
  height?: number;
  disabledHover?: boolean;
  noHover?: boolean;
  note?: string;
  tipType?: 'note' | 'tooltip';
  selected?: boolean;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  isGroup?: boolean;
  singleLine?: boolean;
};

// Dummy component to allow options to be expressed as React elements.
export const Option: React.FC<OptionProps> = () => null;

// Dummy component to allow groups to be expressed as React elements.
// @ts-expect-error - TS2322 - displayName symbol makes this not assignable to ComponentType
export const Group: React.ComponentType<Record<any, any>> = ({
  isGroup: _isGroup = true,
}) => null;

// Assigning as a symbol to ensure uniqueness, used in the dropdown.ts logic
// which utilizes React.Children.map() API under the hood. These "Groups"
// are legacy components and should be using the new Spring components instead.
// @ts-expect-error - not assignable to type string.
Group.displayName = DropdownGroupSymbol;

const _Item = ({
  // @ts-expect-error - TS7031 - Binding element 'value' implicitly has an 'any' type.
  value,
  // @ts-expect-error - TS7031 - Binding element 'onPreselect' implicitly has an 'any' type.
  onPreselect,
  // @ts-expect-error - TS7031 - Binding element 'onChange' implicitly has an 'any' type.
  onChange,
  selectable = true,
  // @ts-expect-error - TS7031 - Binding element 'top' implicitly has an 'any' type.
  top,
  // @ts-expect-error - TS7031 - Binding element 'left' implicitly has an 'any' type.
  left,
  // @ts-expect-error - TS7031 - Binding element 'width' implicitly has an 'any' type.
  width,
  // @ts-expect-error - TS7031 - Binding element 'height' implicitly has an 'any' type.
  height,
  // @ts-expect-error - TS7031 - Binding element 'selected' implicitly has an 'any' type.
  selected,
  // @ts-expect-error - TS7031 - Binding element 'preselected' implicitly has an 'any' type.
  preselected,
  // @ts-expect-error - TS7031 - Binding element 'excludeCheckmarks' implicitly has an 'any' type.
  excludeCheckmarks,
  // @ts-expect-error - TS7031 - Binding element 'disabled' implicitly has an 'any' type.
  disabled,
  // @ts-expect-error - TS7031 - Binding element 'disabledHover' implicitly has an 'any' type.
  disabledHover,
  // @ts-expect-error - TS7031 - Binding element 'indicator' implicitly has an 'any' type.
  indicator,
  // @ts-expect-error - TS7031 - Binding element 'isNoteItem' implicitly has an 'any' type.
  isNoteItem,
  // @ts-expect-error - TS7031 - Binding element 'label' implicitly has an 'any' type.
  label,
  // @ts-expect-error - TS7031 - Binding element 'header' implicitly has an 'any' type.
  header,
  // @ts-expect-error - TS7031 - Binding element 'noHover' implicitly has an 'any' type.
  noHover,
  // @ts-expect-error - TS7031 - Binding element 'SecondaryOption' implicitly has an 'any' type.
  SecondaryOption,
  // @ts-expect-error - TS7031 - Binding element 'onSecondaryClick' implicitly has an 'any' type.
  onSecondaryClick,
  // @ts-expect-error - TS7031 - Binding element 'hasExternalLink' implicitly has an 'any' type.
  hasExternalLink,
  // @ts-expect-error - TS7031 - Binding element 'dataAutomationId' implicitly has an 'any' type.
  'data-automation-id': dataAutomationId,
  // @ts-expect-error - TS7031 - Binding element 'highlightSelectedItem' implicitly has an 'any' type.
  highlightSelectedItem,
  // @ts-expect-error - TS7031 - Binding element 'tipType' implicitly has an 'any' type.
  tipType,
  // @ts-expect-error - TS7031 - Binding element 'note' implicitly has an 'any' type.
  note,
  // @ts-expect-error - TS7031 - Binding element 'style' implicitly has an 'any' type.
  style,
  // @ts-expect-error - TS7031 - Binding element 'singleLine' implicitly has an 'any' type.
  singleLine,
}) => {
  const onMouseEnter = () => onPreselect(value);
  const onClick = () => onChange(value);

  const menuItem = (
    <Menu.Item
      style={{
        position: 'absolute',
        top,
        left,
        width,
        height,
        ...style,
      }}
      header={header}
      hasExternalLink={hasExternalLink}
      noHover={noHover}
      selectable={selectable}
      excludeCheckmarks={excludeCheckmarks}
      selected={selected}
      value={value}
      hover={preselected}
      disabled={disabled}
      disabledHover={disabledHover}
      SecondaryOption={SecondaryOption}
      onSecondaryClick={onSecondaryClick}
      indicator={indicator}
      singleLine={singleLine}
      // @ts-expect-error - TS2322 - Type '{ children: any; style: any; header: any; hasExternalLink: any; noHover: any; selectable: boolean; excludeCheckmarks: any; selected: any; value: any; hover: any; disabled: any; disabledHover: any; SecondaryOption: any; ... 7 more ...; onMouseDown: (e: MouseEvent<...>) => void; }' is not assignable to type 'IntrinsicAttributes & ItemProps<any>'.
      isNoteItem={isNoteItem}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
      data-automation-id={dataAutomationId}
      open={highlightSelectedItem}
      onMouseDown={(e) => {
        // Prevent clicking on the menu item from taking focus
        // from focused element that triggered opening the menu
        e.preventDefault();
      }}
      data-legacy-ds="DropdownItem"
    >
      {React.isValidElement(label)
        ? // @ts-expect-error - TS2769 - No overload matches this call.
          React.cloneElement(label, {hover: preselected && !noHover})
        : typeof label === 'function'
          ? label(preselected && !noHover)
          : label}
    </Menu.Item>
  );

  if (tipType === 'tooltip' && note) {
    return (
      <TooltipTrigger placement="left" content={note} alternate>
        {menuItem}
      </TooltipTrigger>
    );
  }
  return menuItem;
};

const Item = React.memo(_Item);

const _OptionGroup = ({
  // @ts-expect-error - TS7031 - Binding element 'theme' implicitly has an 'any' type.
  theme,
  // @ts-expect-error - TS7031 - Binding element 'computedGroupHeight' implicitly has an 'any' type.
  height: computedGroupHeight,
  // @ts-expect-error - TS7031 - Binding element 'width' implicitly has an 'any' type.
  width,
  // @ts-expect-error - TS7031 - Binding element 'group' implicitly has an 'any' type.
  group,
  // @ts-expect-error - TS7031 - Binding element 'divided' implicitly has an 'any' type.
  divided,
  // @ts-expect-error - TS7031 - Binding element 'scrollOffset' implicitly has an 'any' type.
  scrollOffset,
  // @ts-expect-error - TS7031 - Binding element 'SecondaryOption' implicitly has an 'any' type.
  SecondaryOption,
  // @ts-expect-error - TS7031 - Binding element 'startIndex' implicitly has an 'any' type.
  startIndex,
  // @ts-expect-error - TS7031 - Binding element 'endIndex' implicitly has an 'any' type.
  endIndex,
  // @ts-expect-error - TS7031 - Binding element 'selectedValue' implicitly has an 'any' type.
  selectedValue,
  // @ts-expect-error - TS7031 - Binding element 'preselectedValue' implicitly has an 'any' type.
  preselectedValue,
  // @ts-expect-error - TS7031 - Binding element 'excludeCheckmarks' implicitly has an 'any' type.
  excludeCheckmarks,
  // @ts-expect-error - TS7031 - Binding element 'onPreselect' implicitly has an 'any' type.
  onPreselect,
  // @ts-expect-error - TS7031 - Binding element 'onChange' implicitly has an 'any' type.
  onChange,
  // @ts-expect-error - TS7031 - Binding element 'onSecondaryClick' implicitly has an 'any' type.
  onSecondaryClick,
  // @ts-expect-error - TS7031 - Binding element 'dataAutomationId' implicitly has an 'any' type.
  'data-automation-id': dataAutomationId,
  // @ts-expect-error - TS7031 - Binding element 'highlightSelectedItem' implicitly has an 'any' type.
  highlightSelectedItem,
}) => {
  let prevItemTop =
    (startIndex ? calculateOptionPositions(theme)(group)[startIndex - 1] : 0) +
    theme.dropdown.groupVerticalPadding;

  return (
    <Menu.Wrapper
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width,
        height: computedGroupHeight,
        transform: translate(0, scrollOffset),
      }}
      divided={divided}
      data-automation-id={dataAutomationId}
      data-legacy-ds="Dropdown"
    >
      {times(endIndex - startIndex + 1, (i) => {
        const index = i + startIndex;
        const option = group.children[index];
        const value = getValue(option);
        const optionHeight = getOptionHeight(option, group, theme);
        const margins = getOptionMargins(option, group, theme);
        const totalHeight = optionHeight + margins.bottom;

        const currentItemTop = prevItemTop + margins.top;
        prevItemTop = currentItemTop + totalHeight;

        const automationId = getAutomationId(option[DATA_AUTOMATION_ID])
          ? getAutomationId(option[DATA_AUTOMATION_ID])
          : getLabel(option);

        const isNoteItem =
          option.disabled &&
          option.selectable === false &&
          option.value === null;

        return (
          <Item
            key={index}
            top={currentItemTop}
            left={0}
            width={width}
            height={optionHeight}
            SecondaryOption={SecondaryOption}
            data-automation-id={automationId}
            disabled={option.disabled}
            disabledHover={option.disabledHover}
            value={value}
            label={getLabel(option)}
            indicator={option.indicator}
            isNoteItem={isNoteItem}
            selected={selectedValue === value}
            selectable={option.selectable}
            header={option.header}
            noHover={option.noHover}
            preselected={preselectedValue === value}
            excludeCheckmarks={excludeCheckmarks}
            onPreselect={onPreselect}
            onChange={onChange}
            onSecondaryClick={onSecondaryClick}
            hasExternalLink={option.hasExternalLink}
            highlightSelectedItem={highlightSelectedItem}
            note={option.note}
            tipType={option.tipType}
            style={option.style}
            singleLine={option.singleLine}
          />
        );
      })}
    </Menu.Wrapper>
  );
};

const OptionGroup = React.memo(_OptionGroup);

const ignoreMouseScrolling = (evt: React.UIEvent<HTMLElement>) => {
  evt.preventDefault();
  evt.stopPropagation();
};

const getScrollTop = (
  hasScrolled: any,
  scrollView: any,
  outerHeight: any,
  viewport: {
    height: number;
    left: number;
    top: number;
    width: number;
    x?: number;
    y?: number;
  },
  // @ts-expect-error - TS7006 - Parameter 'theme' implicitly has an 'any' type.
  theme,
  value: any,
  // @ts-expect-error - TS7006 - Parameter 'children' implicitly has an 'any' type.
  children
) => {
  if (hasScrolled) {
    return scrollView.scrollTop;
  }

  if (outerHeight > viewport.height) {
    return clamp(
      selectedTop(theme)(value, children),
      0,
      outerHeight - viewport.height
    );
  } else {
    return 0;
  }
};

// FIXME: removing `themeable` exposed the untyped export of DropdownMenu
/**
 * @deprecated use `Menu` (for triggering an action) or `Select` (for choosing an option value) from `@packages/systems/spring` instead
 */
export const DropdownMenu = (props: Record<any, any>) => {
  const theme = useTheme();
  const viewport = useSpringModalViewport();
  const {
    width = 240,
    maxHeight,
    distanceToMaxHeight,
    anchor,
    scrollView,
    hasScrolled,
    open,
    fixedHeight,
    SecondaryOption,
    value,
    preselected,
    excludeCheckmarks,
    onPreselect,
    onChange,
    onScroll,
    onRemovePreselection,
    onClose,
    onSecondaryClick,
    anchorTransform,
    showDividers = true,
    dropdownRef,
    restrictViewport = true,
    hideOverlay,
    placeBelowAnchor,
    transform = translate(0, 0, 0),
    'data-automation-id': dataAutomationId,
    // SEE https://github.com/webflow/webflow/issues/14662
    __temporaryVerticalPlacementHackTillWeDetermineAPI,
    __temporaryOverrideFinalPlacement, // This is just an escape hatch to say that you're smarter than math, as this component does auto-calculations
    highlightSelectedItem,
  } = props;

  const {nodeId} = useRegisterLegacyOverlay({isOpen: open});
  if (open !== true) return null;

  let {children} = props;

  // if not an array, then only one child is present
  if (children && React.Children.count(children) === 1) {
    children = React.Children.toArray(children);
  }

  // remove any `null` children, so that the parent can implement
  // conditional logic inside the dropdown
  children = children.filter(Boolean);

  const outerHeight = menuHeight(theme)(children);

  const paddedAnchor = anchorTransform
    ? anchorTransform(anchor)
    : pad(theme.gutters.wide)(anchor);

  // Make sure we don't position the dropdown flush
  // with the left or right edge of the viewport
  const restrictedViewport = restrictViewport
    ? padHorizontal(-1 * theme.dropdown.horizontalViewportPadding)(viewport)
    : viewport;

  const maxH =
    maxHeight ||
    (placeBelowAnchor
      ? viewport.height - paddedAnchor.top - paddedAnchor.height
      : viewport.height);

  const box = {
    top: 0,
    left: 0,
    width,
    height: Math.min(outerHeight, maxH),
  } as const;

  const fixedBox = {
    ...box,
    height: fixedHeight || box.height + (distanceToMaxHeight || 0),
  } as const;

  // Find best placement preferring `bottom`.
  const placementLocation = place('bottom')(
    restrictedViewport,
    paddedAnchor,
    fixedBox
  );

  const positioningAnchor = paddedAnchor;

  let layout = positions[placementLocation](
    restrictedViewport,
    positioningAnchor,
    box
  );

  if (placementLocation !== 'bottom') {
    layout = {
      ...layout,
      top: Math.max(paddedAnchor.top - fixedBox.height, 0),
    };
  }

  if (__temporaryVerticalPlacementHackTillWeDetermineAPI === 'left') {
    layout = {
      ...layout,
      top: paddedAnchor.top + paddedAnchor.height,
      left: layout.left + paddedAnchor.width,
    };
  }

  if (__temporaryVerticalPlacementHackTillWeDetermineAPI === 'right') {
    layout = {
      ...layout,
      top: paddedAnchor.top + paddedAnchor.height,
      left: layout.left - Math.round((fixedBox.width - anchor.width) / 2),
    };
  }

  if (typeof __temporaryOverrideFinalPlacement === 'function') {
    layout = __temporaryOverrideFinalPlacement(layout);
  }

  // Unless the user scrolled, we want to scroll to the selected item.
  const scrollTop = getScrollTop(
    hasScrolled,
    scrollView,
    outerHeight,
    viewport,
    theme,
    value,
    children
  );
  const scrollHeight = outerHeight;

  return (
    <FloatingNode id={nodeId}>
      <Layer>
        {hideOverlay ? null : (
          <OverlayBox
            onMouseEnter={onRemovePreselection}
            onClick={onClose}
            onWheel={ignoreMouseScrolling}
          />
        )}

        <div ref={dropdownRef}>
          <Card
            style={{
              fontSize: theme.fontSizes.copy,
              position: 'absolute',
              background: theme.dropdown.backgroundColor,
              top: layout.top,
              left: layout.left,
              width: layout.width,
              height: layout.height,
              transform,
              boxSizing: 'content-box',
            }}
            data-automation-id={dataAutomationId}
          >
            <ScrollView
              showShadows={false}
              width={layout.width}
              height={layout.height}
              scrollWidth={layout.width}
              scrollHeight={scrollHeight}
              scrollTop={scrollTop}
              scrollLeft={0}
              onScroll={onScroll}
            >
              {
                groups(children).reduce(
                  // @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'group' implicitly has an 'any' type. | TS7006 - Parameter 'groupIndex' implicitly has an 'any' type.
                  (result, group, groupIndex) => {
                    const height = groupHeight(theme)(group);
                    const topDelta = result.top - result.current;

                    // Out of view
                    if (topDelta > height || -topDelta > result.height) {
                      return {
                        groups: result.groups,
                        current: result.current + height,
                        top: result.top,
                        height: result.height,
                      };
                    }

                    const startIndex = Math.max(
                      0,
                      indexInGroup(theme)(topDelta)
                    );
                    const endIndex = Math.min(
                      group.children.length - 1,
                      indexInGroup(theme)(topDelta + result.height)
                    );

                    return {
                      groups: result.groups.concat(
                        <OptionGroup
                          key={groupIndex}
                          theme={theme}
                          height={height}
                          scrollOffset={result.current - scrollTop}
                          width={layout.width}
                          divided={
                            !group.hideDivider && showDividers && groupIndex > 0
                          }
                          group={group}
                          startIndex={startIndex}
                          SecondaryOption={SecondaryOption}
                          endIndex={endIndex}
                          selectedValue={value}
                          preselectedValue={preselected}
                          excludeCheckmarks={excludeCheckmarks}
                          onPreselect={onPreselect}
                          onChange={onChange}
                          onSecondaryClick={onSecondaryClick}
                          data-automation-id={group['data-automation-id']}
                          highlightSelectedItem={highlightSelectedItem}
                        />
                      ),
                      current: result.current + height,
                      top: result.top,
                      height: result.height,
                    };
                  },
                  {
                    groups: emptyArray,
                    current: 0,
                    top: scrollTop > 0 ? scrollTop : 0,
                    height: layout.height,
                  }
                ).groups
              }
            </ScrollView>
          </Card>
        </div>
      </Layer>
    </FloatingNode>
  );
};

type DropdownProps = {
  button?:
    | React.ReactElement<
        React.ComponentProps<
          React.ComponentType<{
            onClick: () => void;
            onKeyDown: () => void;
            open: boolean;
          }>
        >
      >
    | ((arg1: {
        onOpen: () => void;
        onKeyDown: () => void;
      }) => React.ReactElement<
        React.ComponentProps<React.ComponentType<Record<any, any>>>
      >);
  dropdownRef?: any;
  onOpen: () => void;
  onClose?: () => void;
  onKeyDown: () => void;
  open: boolean;
  ['data-automation-id']?: string;
};

/**
 * @deprecated use `Menu` (for triggering an action) or `Select` (for choosing an option value) from `@packages/systems/spring` instead
 */
export const Dropdown = ({button, ...props}: DropdownProps) => {
  if (!button) {
    return <DropdownMenu {...props} />;
  }

  // button={<span>Click me!</span>} or button={props => <span>click me!</span>} or button={renderButton} (CC)
  const buttonElement =
    typeof button === 'function'
      ? button(
          extend(
            {},
            {
              onClick: props.onOpen,
              onKeyDown: props.onKeyDown,
              open: props.open,
            },
            props
          )
        )
      : React.cloneElement(button, {
          // @ts-expect-error - TS2769 - No overload matches this call. | TS7006 - Parameter 'event' implicitly has an 'any' type.
          onClick: (event) => {
            // @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
            button.props.onClick && button.props.onClick(event);
            props.onOpen();
          },
          onKeyDown: props.onKeyDown,
          open: props.open,
        });

  return (
    <Locator>
      {(ref, anchor) => {
        return (
          <>
            <div ref={ref}>{buttonElement}</div>
            {anchor && <DropdownMenu anchor={anchor} {...props} />}
          </>
        );
      }}
    </Locator>
  );
};

const enhance = compose(
  syncPropsToState({
    state: {
      updaterName: 'setState',
      initialValue: getInitialState({value: 0}),
    },
  }),
  withHandlers({
    onScroll:
      // @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'children' implicitly has an 'any' type.

      ({setState, state, children}) =>
        (value: any) => {
          setState(scroll({...state, children}, value));
        },
    onOpen:
      // @ts-expect-error - TS7031 - Binding element 'open' implicitly has an 'any' type. | TS7031 - Binding element 'onOpen' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'handleOpen' implicitly has an 'any' type.

      ({open, onOpen, setState, handleOpen}) =>
        (event: any) => {
          if (!open) {
            handleOpen ? handleOpen() : setState(openUpdater);

            if (onOpen) {
              onOpen(event);
            }
          }
        },
    onClose:
      // @ts-expect-error - TS7031 - Binding element 'onClose' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'handleClose' implicitly has an 'any' type.

      ({onClose, setState, handleClose}) =>
        (event: any) => {
          // Stop click events on the box overlay from bubbling up the DOM tree.
          // This was an issue with dropdowns inside other interactive content like an expand/collapse section,
          // where clicking outside the dropdown on the overlay would then trigger a click on the section to
          // inadvertently expand/collapse it.
          event?.stopPropagation?.();
          handleClose ? handleClose() : setState(close);
          if (onClose) {
            onClose(event);
          }
        },
    onPreselect:
      // @ts-expect-error - TS7031 - Binding element 'handlePreselect' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'onPreselect' implicitly has an 'any' type. | TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'children' implicitly has an 'any' type.

      ({handlePreselect, setState, onPreselect, state, children}) =>
        (value: any) => {
          handlePreselect
            ? handlePreselect(value)
            : setState(preselect({...state, children}, value));
          if (onPreselect) {
            onPreselect(value);
          }
        },
    onRemovePreselection:
      // @ts-expect-error - TS7031 - Binding element 'onRemovePreselection' implicitly has an 'any' type. | TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'children' implicitly has an 'any' type.

      ({onRemovePreselection, setState, state, children}) =>
        () => {
          setState(preselect({...state, children}, null));
          if (onRemovePreselection) {
            onRemovePreselection();
          }
        },
    onChange:
      // @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type. | TS7031 - Binding element 'state' implicitly has an 'any' type. | TS7031 - Binding element 'children' implicitly has an 'any' type. | TS7031 - Binding element 'handleChange' implicitly has an 'any' type. | TS7031 - Binding element 'handleClose' implicitly has an 'any' type. | TS7031 - Binding element 'remainOpen' implicitly has an 'any' type.

      ({setState, state, children, handleChange, handleClose, remainOpen}) =>
        (value: any) => {
          if (handleChange) {
            handleChange(value);

            if (!remainOpen) {
              handleClose ? handleClose() : setState(close);
            }
          } else {
            setState(change({...state, children}, value));
          }
        },
    onKeyDown:
      ({
        // @ts-expect-error - TS7031 - Binding element 'handleClose' implicitly has an 'any' type.
        handleClose,
        // @ts-expect-error - TS7031 - Binding element 'handleKeyDown' implicitly has an 'any' type.
        handleKeyDown,
        // @ts-expect-error - TS7031 - Binding element 'setState' implicitly has an 'any' type.
        setState,
        // @ts-expect-error - TS7031 - Binding element 'state' implicitly has an 'any' type.
        state,
        // @ts-expect-error - TS7031 - Binding element 'children' implicitly has an 'any' type.
        children,
        // @ts-expect-error - TS7031 - Binding element 'handleChange' implicitly has an 'any' type.
        handleChange,
        ...rest
      }) =>
      (event: any) => {
        event.stopPropagation();
        if (handleKeyDown) {
          handleKeyDown(event);
        } else {
          const newState = onKeyDown({...state, children}, event.key);
          setState(newState);

          if (rest && rest.onKeyDown) {
            rest.onKeyDown(newState.preselected);
          }

          if (handleChange && (event.key === 'Enter' || event.key === ' ')) {
            handleChange(newState.value);
          }
        }

        if (event.key === 'Escape' || event.key === 'Tab') {
          handleClose ? handleClose() : setState(close);
        }
      },
  })
);

/**
 * @deprecated use `Menu` (for triggering an action) or `Select` (for choosing an option value) from `@packages/systems/spring` instead
 */
// @ts-expect-error - TS7006 - Parameter 'props' implicitly has an 'any' type.
export const EnhancedDropdown = enhance((props) => {
  const {state} = props;
  return <Dropdown {...state} {...props} />;
});

type EnhancedDropdownWithNoteProps = {
  onPreselect?: () => void;
  onRemovePreselection?: () => void;
  onClose?: () => void;
  dropdownData: Array<EnhancedDropdownWithNoteDataProps>;
  dropdownDefaultNote?: {
    note: string;
    noteLines: number;
  };
  button?: React.ReactElement<any>;
  handleChange: (arg1?: any) => void;
  width?: number;
  dropdownElement?: React.ReactElement<any>;
  __temporaryVerticalPlacementHackTillWeDetermineAPI?: string;
  transform?: string;
  value?: string;
  highlightSelectedItem?: boolean;
  showNoteIcon?: boolean;
};

export type EnhancedDropdownWithNoteDataProps = {
  id: string;
  label: React.ReactNode;
  note?: string;
  tipType?: 'note' | 'tooltip';
  noteLines?: number;
  height?: number;
  header?: boolean;
  ['data-automation-id']?: string;
  disabled?: boolean;
  disabledHover?: boolean;
  miniNoteProps?: {
    icon?: React.ReactNode;
    header?: boolean | React.ReactNode;
    warning?: boolean;
    alt?: boolean;
  };
  style?: CSSProperties;
  noHover?: boolean;
};

/**
 * @deprecated use `Menu` (for triggering an action) or `Select` (for choosing an option value) from `@packages/systems/spring` instead
 */
export function EnhancedDropdownWithNote(props: EnhancedDropdownWithNoteProps) {
  const dropdownDataRef = React.useRef(props.dropdownData);
  const dropdownDefaultNoteRef = React.useRef(props.dropdownDefaultNote);
  dropdownDataRef.current = props.dropdownData;
  dropdownDefaultNoteRef.current = props.dropdownDefaultNote;

  const {fontSizes, lineHeights, dropdown} = useTheme();

  const [hovered, setHovered] = React.useState<string>('');

  const [height, setHeight] = React.useState(0);
  const noteHeight = height + dropdown.horizontalPadding * 2;

  const options = getOptions(dropdownDataRef.current);

  const currentItem = React.useMemo(() => {
    return dropdownDataRef.current && hovered
      ? dropdownDataRef.current.find(
          (item) => item.id === hovered && item.tipType !== 'tooltip'
        )
      : null;
  }, [hovered]);

  const noteContent = currentItem?.note ?? dropdownDefaultNoteRef.current?.note ?? ''; // prettier-ignore
  const currentNoteLines = currentItem?.noteLines ?? dropdownDefaultNoteRef.current?.noteLines ?? 1; // prettier-ignore
  const {header, warning, icon} = currentItem?.miniNoteProps ?? {};

  /**
   * When the dropdown menu opens on the top side of the button, and the height varies
   * due to hovering over items that cause a different note height, we want the menu to
   * stay at the same top position instead of at the same bottom position. Otherwise the
   * changed height would also shift up the position of the items, which is not nice UX.
   *
   * To make sure the Dropdown menu can always calculate the maximum height of the menu,
   * we supply the distance to the max height.
   */
  const distanceToMaxHeight = React.useMemo(() => {
    const allNoteLines = [
      ...dropdownDataRef.current,
      dropdownDefaultNoteRef.current,
    ].map((item) => (item && item.noteLines) || 0);
    const maxNoteLines = Math.max(...allNoteLines);
    const miniNoteLineHeight = lineHeights.text * fontSizes.copy;
    return (maxNoteLines - currentNoteLines) * miniNoteLineHeight;
  }, [fontSizes, lineHeights, currentNoteLines]);

  const onHover = (id: string) => {
    setHovered((prevId) => (id ? id : prevId));
    props.onPreselect && props.onPreselect();
  };

  const onMouseOut = () => {
    setHovered('');
    props.onRemovePreselection && props.onRemovePreselection();
  };

  const onDropdownKeyDown = (id: string) => {
    setHovered((prevId) => (id ? id : prevId));
  };

  return (
    <EnhancedDropdown
      {...props}
      onPreselect={onHover}
      onRemovePreselection={onMouseOut}
      onKeyDown={onDropdownKeyDown}
      distanceToMaxHeight={distanceToMaxHeight}
    >
      {noteContent
        ? [
            <Group key="dropdownOptions">{options}</Group>,
            <Group key="dropdownNote" customHeight={noteHeight}>
              <Option
                disabled
                selectable={false}
                value={null}
                isNoteItem
                label={
                  <Note
                    ref={(el) => {
                      if (el) {
                        const bounds = el.getBoundingClientRect();
                        setHeight(bounds.height);
                      }
                    }}
                    isNested
                    hasIcon={props.showNoteIcon}
                    icon={icon}
                    colorVariant={warning ? 'warning' : 'default'}
                    // @ts-expect-error - TS2322 - Type '{} | undefined' is not assignable to type '((boolean | ReactChild | ReactFragment | ReactPortal | null) & string) | undefined'.
                    title={header ? header : undefined}
                  >
                    {noteContent}
                  </Note>
                }
              />
            </Group>,
          ]
        : options}
    </EnhancedDropdown>
  );
}

// @ts-expect-error - TS7006 - Parameter 'dropdownData' implicitly has an 'any' type.
const getOptions = (dropdownData) =>
  // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
  dropdownData.map((item) => {
    return (
      <Option
        key={item.id}
        value={item.id}
        header={item.header}
        label={item.label}
        height={item.height}
        disabled={item.disabled}
        disabledHover={item.disabledHover}
        noHover={item.noHover}
        data-automation-id={item['data-automation-id'] || item.id}
        note={item.note}
        tipType={item.tipType}
        style={item.style}
      />
    );
  });
